const Variant = Object.freeze({
  status: {
    DANGER: 'DANGER',
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
  },
});

export default Variant;
